import Vue from "vue";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import Axios from "axios";
import UrlHelper from "@Scripts/Infrastructure/UrlHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "CookieToast"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.setNavigation();
        this.setMenuCollapse();
        this.setIsLayout();
        this.setPrint();
        this.setLangDialog();
        if (navigator.onLine && (<any>window)._paq) {
            this.setMatomoEvents();
        }
        this.openCookieToastDialog();
        this.setAsideNavigation();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setIsLayout() {
        const wrapper = document.getElementById("wrapper");

        let isLayoutHidden = window.localStorage.getItem("IsLayoutHidden") === "true";

        let paramIsLayoutHidden = UrlHelper.getUrlParamValue("islayouthidden");
        if (paramIsLayoutHidden) {
            isLayoutHidden = paramIsLayoutHidden === "true";
            window.localStorage.setItem("IsLayoutHidden", paramIsLayoutHidden === "true" ? "true" : "false");
        }

        let isFooterHidden = window.localStorage.getItem("IsFooterHidden") === "true";

        let paramIsFooterHidden = UrlHelper.getUrlParamValue("isfooterhidden");
        if (paramIsFooterHidden) {
            isFooterHidden = paramIsFooterHidden === "true";
            window.localStorage.setItem("IsFooterHidden", paramIsFooterHidden === "true" ? "true" : "false");
        }

        if (isLayoutHidden) {
            wrapper.dataset.mode = "embed";
        } else if (isFooterHidden) {
            wrapper.dataset.mode = "footerhidden";
        } else {
            wrapper.dataset.mode = "webpages";
        }
    }

    private static setMenuCollapse() {
        const buttonCollapse = document.getElementById("button-collapse");
        const page = document.getElementById("page");

        let isButtonCollapseOpen = window.localStorage.getItem("IsMenuHidden") === "true";

        let paramIsMenuHidden = UrlHelper.getUrlParamValue("ismenuhidden");
        if (paramIsMenuHidden) {
            isButtonCollapseOpen = paramIsMenuHidden === "true";
            window.localStorage.setItem("IsMenuHidden", paramIsMenuHidden === "true" ? "true" : "false");
        }

        if (isButtonCollapseOpen) {
            buttonCollapse.classList.add("active");
            page.classList.add("collapse");
        } else {
            buttonCollapse.classList.remove("active");
            page.classList.remove("collapse");
        }

        buttonCollapse.addEventListener("click", function () {
            buttonCollapse.classList.toggle("active");
            page.classList.toggle("collapse");

            const isButtonCollapseOpen = buttonCollapse.classList.contains("active");
            window.localStorage.setItem("IsMenuHidden", isButtonCollapseOpen.toString());
        });
    }

    private static setNavigation() {
        let app = document.getElementById("body"),
            scrim = document.getElementById("scrim"),
            openMenu = document.getElementById("open-menu"),
            aside = document.getElementById("aside"),
            header = document.getElementById("header"),
            openSearch = document.getElementById("open-search"),
            closeSearch = document.getElementById("close-search"),
            search = document.getElementById("search");

        if (scrim) {
            scrim.addEventListener("click", function () {
                app.classList.remove("overflow");
                scrim.classList.remove("show");
                aside.classList.remove("show");
                header.classList.remove("over");
                search.classList.remove("show");
            });
        }

        if (openMenu) {
            openMenu.addEventListener("click", function () {
                app.classList.add("overflow");
                scrim.classList.add("show");
                aside.classList.add("show");
            });
        }

        if (openSearch) {
            openSearch.addEventListener("click", function () {
                app.classList.add("overflow");
                header.classList.add("over");
                scrim.classList.add("show");
                search.classList.add("show");
            });
        }

        if (closeSearch) {
            closeSearch.addEventListener("click", function () {
                app.classList.remove("overflow");
                header.classList.remove("over");
                scrim.classList.remove("show");
                search.classList.remove("show");
            });
        }
    }

    private static setPrint() {
        function stampaPagina() {
            (<any>window)._paq?.push(["trackEvent", "Print", "Click", document.getElementById("TitlePage").innerText]);
            window.print();
        }

        var printButton = document.getElementById("stampabtn");
        printButton?.addEventListener("click", stampaPagina);
    }

    private static setMatomoEvents() {
        setTimeout(x => {
            (<any>window)._paq?.push(["trackEvent", "Engagement", "Read", "10"]);
        }, 10000);

        let isMatomo25: boolean = false;
        let isMatomo50: boolean = false;
        let isMatomo75: boolean = false;
        let isMatomo100: boolean = false;

        const scrollHandler = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;

            if (scrollPercentage >= 25 && scrollPercentage < 50) {
                if (!isMatomo25) {
                    (<any>window)._paq?.push(["trackEvent", "Engagement", "Scroll", "25"]);
                    isMatomo25 = true;
                }
            } else if (scrollPercentage >= 50 && scrollPercentage < 75) {
                if (!isMatomo50) {
                    (<any>window)._paq?.push(["trackEvent", "Engagement", "Scroll", "50"]);
                    isMatomo50 = true;
                }
            } else if (scrollPercentage >= 75 && scrollPercentage < 100) {
                if (!isMatomo75) {
                    (<any>window)._paq?.push(["trackEvent", "Engagement", "Scroll", "75"]);
                    isMatomo75 = true;
                }
            } else if (scrollPercentage === 100) {
                if (!isMatomo100) {
                    (<any>window)._paq?.push(["trackEvent", "Engagement", "Scroll", "100"]);
                    isMatomo100 = true;
                }
            }
        };

        window.addEventListener('scroll', scrollHandler);

        let links = document.querySelectorAll(".editor a");
        for (const item of links) {
            if (item) {
                item.addEventListener("click", function (event) {
                    (<any>window)._paq?.push(["trackEvent", "Page", "Click", this.getAttribute("href")]);
                }, false);
            }
        }
    }

    private static openCookieToastDialog() {
        let ctas = document.querySelectorAll("[data-cookietoast]");
        for (const item of ctas) {
            item.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("cookieToastStore/setCookieToastVisible", true);
            })
        }
    }

    private static setLangDialog() {
        let app = document.getElementById("body"),
            diglog = document.querySelectorAll(".lang"),
            openLang = document.querySelectorAll(".button-action")

        for (const item of openLang) {
            if (item) {
                item.addEventListener("click", function () {
                    app.classList.toggle("overflow");
                    for (const item of diglog) {
                        item.classList.toggle("show");
                    }
                });
            }
        }
    }   

    private static setAsideNavigation() {
        let titles = document.querySelectorAll(".title-wrapper");
        let pagelinks = document.querySelectorAll("[data-name]");
        let groupName = (<any>window).App.bag.GroupName;

        for (const title of titles) {
            title.addEventListener("click", function () {
                let dataName = title.getAttribute("data-name");
                
                for (const pagelink of pagelinks) {
                    if (pagelink.getAttribute("data-name") !== dataName) {
                        pagelink.classList.remove("show");
                    }
                }

                var titleLinks = document.querySelectorAll("[data-name="+dataName+"]");
                for (const item of titleLinks) {
                    item.classList.toggle("show");
                }
            }, false);
            
        }
        for (const pagelink of pagelinks) {
            let dataName = pagelink.getAttribute("data-name");
            if (groupName === dataName) {
                pagelink.classList.toggle('show');

                var titleLinks = document.querySelectorAll(".title-wrapper[data-name="+dataName+"]");
                for (const item of titleLinks) {
                    if (!item.classList.contains("show")) {
                        item.classList.add("show");
                    }
                }
            }
        }

        let currentPage = document.querySelector(".item[data-selected]");
        let box = document.querySelector(".nav");
        
        if (!currentPage || !box) return;
        
        const elementRect = currentPage.getBoundingClientRect();
        const boxRect = box.getBoundingClientRect();
        
        const isVisible = (element, container) => {
          const { top, bottom } = element.getBoundingClientRect();
          const { top: containerTop, bottom: containerBottom } = container.getBoundingClientRect();
        
          return top >= containerTop && bottom <= containerBottom;
        };
        
        if (!isVisible(currentPage, box)) {
          const offset = elementRect.top - boxRect.top - (boxRect.height / 2) + (elementRect.height / 2);
        
          box.scrollTo({
            top: box.scrollTop + offset,
            behavior: 'instant'
          });
        }         
    }
}